<script setup lang="ts">
export interface VideoProps {
    videoSrc?: string
    videoId?: string
}

defineProps<VideoProps>()
</script>

<template>
    <section class="fullscreen-video">
        <UIIframe v-if="videoSrc || videoId" :video-id="videoId" :src="videoSrc" />
        <div class="video-gradient" />
    </section>
</template>

<style scoped lang="scss">
.fullscreen-video {
    position: relative;
    height: 0;
    background-color: rgb(0 0 0 / 20%);
    aspect-ratio: 16 / 9;
    width: 100%;
    height: 100%;
    max-width: 1280px;
    margin: 0 auto;

    .video-gradient {
        position: absolute;
        bottom: -1px; // Hack to avoid gap in some scenarios
        height: 100%;
        width: 100%;
        background: linear-gradient(to bottom, transparent 30%, var(--background) 100%);
        z-index: 4;
        pointer-events: none;

        @media (min-width: 1280px) {
            &:before {
                content: '';
                position: absolute;
                top: -1px;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(to right, transparent 80%, var(--background) 100%);
            }

            &:after {
                content: '';
                position: absolute;
                top: -1px;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(to left, transparent 80%, var(--background) 100%);
            }
        }
    }
}
</style>
